// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4730":"25f83588","9215":"f4ac3aea"}[chunkId] + ".chunk.css";
};